import { Button } from "@portal/BaseComponents/Button/AntButton";
import styled from "styled-components";

export const StyledFilterBlock = styled(Button)`
  width: auto;
  padding: var(--space-8) var(--space-12);
  .show-on-hover {
    opacity: 0;
  }
  &:hover {
    .show-on-hover {
      opacity: 1;
    }
  }
`;
